import { Book, BookTemplate, ReduxThunk } from '../types';

export const setDisplayedStatus = (status: string) => ({
    type: 'SET_DISPLAYED_STATUS',
    payload: status,
});

export const toggleIsFetching = (status: boolean) => ({
    type: 'TOGGLE_IS_FETCHING',
    payload: status,
});

export const setDataIsLoaded = () => ({
    type: 'SET_DATA_IS_LOADED',
    payload: null,
});

export const setError = (error: string) => ({
    type: 'SET_ERROR',
    payload: error,
});

type dummyType = {
    completed: Book[],
    reading: Book[],
    backlog: Book[],
};

const dummy: dummyType = {
    "completed": [
        {
            "title": "Harry Potter and the Philosopher's Stone",
            "authors": [
                "J.K. Rowling"
            ],
            "coverImage": "https://covers.openlibrary.org/b/olid/OL22856696M-S.jpg",
            "status": "completed",
            "_links": {
                "self": {
                    "href": "http://localhost:8080/api/books/60b5307b627e6459fccb7742"
                },
                "book": {
                    "href": "http://localhost:8080/api/books/60b5307b627e6459fccb7742"
                }
            }
        },
        {
            "title": "Harry Potter and the Chamber of Secrets",
            "authors": [
                "J.K. Rowling"
            ],
            "coverImage": "https://covers.openlibrary.org/b/olid/OL25631456M-S.jpg",
            "status": "completed",
            "_links": {
                "self": {
                    "href": "http://localhost:8080/api/books/60b5330a7e4e7e44b22389f7"
                },
                "book": {
                    "href": "http://localhost:8080/api/books/60b5330a7e4e7e44b22389f7"
                }
            }
        },
        {
            "title": "Harry Potter and the Prisoner of Azkaban",
            "authors": [
                "J.K. Rowling"
            ],
            "coverImage": "http://covers.openlibrary.org/b/olid/OL26234270M-S.jpg",
            "status": "completed",
            "_links": {
                "self": {
                    "href": "http://localhost:8080/api/books/60b6685a995a371b7a0564f4"
                },
                "book": {
                    "href": "http://localhost:8080/api/books/60b6685a995a371b7a0564f4"
                }
            }
        }
    ],
    "reading": [
        {
            "title": "Harry Potter and the Goblet of Fire",
            "authors": [
                "J.K. Rowling"
            ],
            "coverImage": "https://covers.openlibrary.org/b/olid/OL6800755M-S.jpg",
            "status": "reading",
            "_links": {
                "self": {
                    "href": "http://localhost:8080/api/books/60b66864995a371b7a0564f5"
                },
                "book": {
                    "href": "http://localhost:8080/api/books/60b66864995a371b7a0564f5"
                }
            }
        },
        {
            "title": "Harry Potter and the Order of the Phoenix",
            "authors": [
                "J.K. Rowling"
            ],
            "coverImage": "https://covers.openlibrary.org/b/olid/OL25662116M-S.jpg",
            "status": "reading",
            "_links": {
                "self": {
                    "href": "http://localhost:8080/api/books/60b66864995a371b7a0564f6"
                },
                "book": {
                    "href": "http://localhost:8080/api/books/60b66864995a371b7a0564f6"
                }
            }
        },
        {
            "title": "Harry Potter and the Half-Blood Prince",
            "authors": [
                "J.K. Rowling"
            ],
            "coverImage": "https://covers.openlibrary.org/b/olid/OL24190024M-S.jpg",
            "status": "reading",
            "_links": {
                "self": {
                    "href": "http://localhost:8080/api/books/60b66864995a371b7a0564f7"
                },
                "book": {
                    "href": "http://localhost:8080/api/books/60b66864995a371b7a0564f7"
                }
            }
        },
    ],
    "backlog": [
        {
            "title": "Harry Potter and the Deathly Hallows",
            "authors": [
                "J.K. Rowling"
            ],
            "coverImage": "https://covers.openlibrary.org/b/olid/OL28172760M-S.jpg",
            "status": "backlog",
            "_links": {
                "self": {
                    "href": "http://localhost:8080/api/books/60b66864995a371b7a0564f8"
                },
                "book": {
                    "href": "http://localhost:8080/api/books/60b66864995a371b7a0564f8"
                }
            }
        },
        {
            "title": "Harry Potter and the Ridiculously Long Title To Test How Responsive the UI of This App Is",
            "authors": [
                "J.K. Rowling"
            ],
            "coverImage": null,
            "status": "backlog",
            "_links": {
                "self": {
                    "href": "http://localhost:8080/api/books/60b534500ec47c77f6c4bf37"
                },
                "book": {
                    "href": "http://localhost:8080/api/books/60b534500ec47c77f6c4bf37"
                }
            }
        }
    ]
}

export function getBooks(status: string = 'reading'): ReduxThunk {
    return async (dispatch, getState) => {
        if (!getState().isFetching) {
            dispatch(toggleIsFetching(true));
            try {
                dispatch(toggleIsFetching(false));

                let bookz = [];

                if (status === 'completed') {
                    bookz = dummy.completed;
                } else if (status === 'reading') {
                    bookz = dummy.reading;
                } else {
                    bookz = dummy.backlog;
                }

                dispatch({
                    type: 'GET_BOOKS',
                    payload: bookz,
                });
            } catch (error) {
                dispatch(toggleIsFetching(false));
                dispatch(setError(error));
            }
        }
    }
}

export function addBook(bookTemplate: BookTemplate): ReduxThunk {
    return async (dispatch, getState) => {
        if (!getState().isFetching) {
            dispatch(toggleIsFetching(true));
            try {

                // Convert authors into array
                const newBook = {
                    title: bookTemplate.title,
                    authors: bookTemplate.authors.split(','),
                    status: bookTemplate.status,
                };

                dispatch(toggleIsFetching(false));
                dispatch({
                    type: 'ADD_BOOK',
                    payload: newBook,
                });
            } catch (error) {
                dispatch(toggleIsFetching(false));
                dispatch(setError(error));
            }
        }
    }
}

export function editBook(updatedBook: Book): ReduxThunk {
    return async (dispatch, getState) => {
        if (!getState().isFetching) {
            dispatch(toggleIsFetching(true));
            try {
                dispatch(toggleIsFetching(false));
                dispatch({
                    type: 'EDIT_BOOK',
                    payload: updatedBook,
                });
            } catch (error) {
                dispatch(toggleIsFetching(false));
                dispatch(setError(error));
            }
        }
    }
}

export function deleteBook(book: Book): ReduxThunk {
    return async (dispatch, getState) => {
        if (!getState().isFetching) {
            dispatch(toggleIsFetching(true));
            try {
                dispatch(toggleIsFetching(false));
                dispatch({
                    type: 'DELETE_BOOK',
                    payload: book._links.self.href,
                });
            } catch (error) {
                dispatch(toggleIsFetching(false));
                dispatch(setError(error));
            }
        }
    }
}